module.exports = __webpack_public_path__ + "img/wenzi_1.e14b4862.png";